'use strict';

const {track, trackGa} = require('../../analytics/analytics');

module.exports = class AnalyticsController {
  constructor(software, currentTariff, currentPeriod, newTariffPlan) {
    this.software = software;
    this.category = `${this.software}|Upgrade`;
    this.currentTariff = currentTariff;
    this.currentPeriod = currentPeriod;
    this.newTariffPlan = newTariffPlan;
  }

  createBasicLabel() {
    return `${this.currentTariff}_${this.currentPeriod}|${this.newTariffPlan}`;
  }

  createUpgradeLabel() {
    this.label = `upgrade_button|${this.createBasicLabel()}`
  }

  createUpdateLabel(method, currency, price) {
    this.label = `update_button|${this.createBasicLabel()}|${method}|${currency}|${price}`
  }

  send(action, type) {
    this.action = `${action}-${type}`;

    if (this.label) {
      trackGa(this.action, this.category, this.label, null, 'beacon', this.software);
      return track(this.category, this.action, this.label, null, this.software);
    }
  }
}